import React from "react";

export const Footer = () => {
  return (
    <footer className="layout-footer"></footer>
  );
};
